import { PhysicalAddress } from '@bufteam/cfacorp_core.bufbuild_es/cfa/core/v1/physical_address_pb';
import { AutoCompleteResult } from '@bufteam/cfacorp_d2c.bufbuild_es/cfa/d2c/frontend/restaurant/v1/restaurant_pb';
import * as z from 'zod';

import { ValidatedDeliveryAddress } from '../order/schemas';
import { AddressResult } from './schemas';

export const autoCompleteToAddressResult = z.transform<AutoCompleteResult, AddressResult>((i) => ({
  placeId: i.placeId,
  structuredFormatting: {
    mainText: i.structuredFormat?.mainText ?? '',
    secondaryText: i.structuredFormat?.secondaryText ?? '',
  },
}));

export const addressResultToAutoComplete = z.transform<AddressResult, AutoCompleteResult>((i) => ({
  $typeName: 'cfa.d2c.frontend.restaurant.v1.AutoCompleteResult',
  placeId: i.placeId,
  structuredFormat: {
    $typeName: 'cfa.d2c.frontend.restaurant.v1.StructuredFormat',
    mainText: i.structuredFormatting.mainText,
    secondaryText: i.structuredFormatting.secondaryText,
  },
}));

export const physicalToValidatedDeliveryAddress = z.transform<PhysicalAddress, ValidatedDeliveryAddress>(
  (physical) => {
    const trimmedAddress = (physical.streetAddress || '').trim();

    if (!trimmedAddress) {
      return {
        streetNumber: undefined,
        route: undefined,
        subpremise: physical.subPremise ?? undefined,
        locality: physical.locality ?? undefined,
        administrativeAreaLevelOne: physical.administrativeAreaLevelOne ?? undefined,
        administrativeAreaLevelTwo: physical.administrativeAreaLevelTwo ?? undefined,
        postalCode: physical.postalCode ?? undefined,
        country: physical.country ?? undefined,
      };
    }

    const streetParts = trimmedAddress.split(' ');
    const streetNumber = streetParts[0];
    const route = streetParts.length > 1 ? streetParts.slice(1).join(' ').trim() : '';

    return {
      streetNumber,
      route,
      subpremise: physical.subPremise ?? undefined,
      locality: physical.locality ?? undefined,
      administrativeAreaLevelOne: physical.administrativeAreaLevelOne ?? undefined,
      administrativeAreaLevelTwo: physical.administrativeAreaLevelTwo ?? undefined,
      postalCode: physical.postalCode ?? undefined,
      country: physical.country ?? undefined,
    };
  },
);
